module.exports = __webpack_public_path__ + "img/05.267f92d8.svg";